module.exports = __webpack_public_path__ + "static/assets/f72da0742e9adbe1d146bd4bd43cf3e9.svg";